import { render, staticRenderFns } from "./FAgeField.vue?vue&type=template&id=4663d4c3&"
import script from "./FAgeField.vue?vue&type=script&lang=ts&"
export * from "./FAgeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports